import { theme } from "../../theme";
import { StyleSheet } from "react-native";
export const styles = StyleSheet.create({
    defaults: {
        position: "relative",
        overflow: "hidden",
        padding: theme.spacing.medium,
    },
    shadow: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.15,
        shadowRadius: 13.16,
        elevation: 15,
    },
    rounded: {
        borderRadius: theme.spacing.xsmall,
    },
    patternContainer: {
        position: "absolute",
        height: "100%",
        width: "100%",
    },
    light: {
        backgroundColor: theme.colors.light.base,
    },
    brand: {
        backgroundColor: theme.colors.brand.base,
        color: theme.colors.light.base,
    },
    accent: {
        backgroundColor: theme.colors.accent.base,
    },
    positive: {
        backgroundColor: theme.colors.positive.base,
    },
    negative: {
        backgroundColor: theme.colors.negative.base,
    },
    warning: {
        backgroundColor: theme.colors.warning.base,
    },
    black: {
        backgroundColor: theme.colors.greyscale.base,
        color: theme.colors.light.base,
    },
    dark: {
        backgroundColor: theme.colors.dark.base,
        color: theme.colors.light.base,
    },
    grey: {
        backgroundColor: theme.colors.greyscale.lightest,
    },
});
//# sourceMappingURL=Panel.styles.js.map